module.exports = __webpack_public_path__ + "img/bp-icon-sts.e4c84247.png";